import { DocumentEditorModalProps } from './DocumentEditorModal';
import { openModal } from '@core/components/ModalStack';

export async function openDocumentEditorModal(props: DocumentEditorModalProps) {
  const { DocumentEditorModal } = await import('./DocumentEditorModal');

  openModal(DocumentEditorModal, props);
}
